export const isValidUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const normalizeUrl = (url: string): string => {
  if (!url.match(/^https?:\/\//i) && !url.match(/^http?:\/\//i)) {
    return 'http://' + url;
  }
  return url;
};

// Task navigation utilities
export interface TaskNavigationOptions {
  orgId: number | string;
  spaceId: number | string;
  taskId: number | string;
}

export const buildTaskUrl = ({ orgId, spaceId, taskId }: TaskNavigationOptions): string => {
  return `/${orgId}/space/${spaceId}/task/${taskId}`;
};

export const buildSpaceUrl = (orgId: number | string, spaceId: number | string): string => {
  return `/${orgId}/space/${spaceId}`;
};

/**
 * Normalizes a URL for opening in a new tab/window
 * Handles various URL formats and adds appropriate protocols
 * @param href The original href value
 * @returns A properly formatted URL ready to open
 */
export const normalizeUrlForOpening = (href: string): string => {
  let urlToOpen = href;

  if (href.startsWith('www.')) {
    urlToOpen = 'https://' + href;
  } else if (!href.startsWith('http://') && !href.startsWith('https://')) {
    if (href.includes('.') && !href.includes(' ')) {
      urlToOpen = 'https://' + href;
    } else {
      try {
        urlToOpen = new URL(href, window.location.origin).href;
      } catch (e) {
        console.error('Failed to parse URL:', href);
        // Return original href if normalization fails
        return href;
      }
    }
  }

  return urlToOpen;
};
